import { render } from "./InstructorSessions.vue?vue&type=template&id=e4c1013a&scoped=true"
import script from "./InstructorSessions.vue?vue&type=script&lang=js"
export * from "./InstructorSessions.vue?vue&type=script&lang=js"

import "./InstructorSessions.vue?vue&type=style&index=0&id=e4c1013a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c1013a"]])

export default __exports__